module.exports = __webpack_public_path__ + "static/img/background00-mercedes-2023.4542526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background00-mercedes-2023.jpg
// module id = X7hC
// module chunks = 1